"use client";

import { LazyAppModals } from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/index";
import { LazyPromoModals } from "@faire/deprecated-retailer-visitor-shared/components/App/PromoModals/index";
import { useAppModal } from "@faire/deprecated-retailer-visitor-shared/stores/ui/AppModalStore";
import { usePromoModalToDisplay } from "@faire/deprecated-retailer-visitor-shared/stores/ui/PromoModalStore";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React, { Suspense, useMemo } from "react";

import { AppModalEnv } from "./ModalTypes";

export const Modal: React.FC<{ appModalEnv: AppModalEnv }> = ({
  appModalEnv,
}) => {
  const isSSR = useIsSSR();
  const { isModalShowing: canShowAppModal } = useAppModal();
  const { modalToDisplay: canShowPromoModal } = usePromoModalToDisplay();

  let modalType: "app" | "promo" | null = null;
  if (canShowAppModal) {
    modalType = "app";
    // TODO(jocelyn): whether a modal is rendered depends on Storage.local,
    // which can cause a hydration mismatch (FD-127421).
    //
    // Once this is fixed, remove this exception.
  } else if (!isSSR && canShowPromoModal) {
    modalType = "promo";
  }

  // We only want to rerender the modal when the modal type changes. This can
  // help avoid SSR misses for the modal caused by internal modal state
  // changes that trigger this component to be re-rendered but do not affect
  // the render output.
  return useMemo(() => {
    if (modalType === "app") {
      return (
        <Suspense fallback={null}>
          <LazyAppModals appModalEnv={appModalEnv} />
        </Suspense>
      );
    } else if (modalType === "promo") {
      return (
        <Suspense fallback={null}>
          <LazyPromoModals />
        </Suspense>
      );
    }

    return null;
  }, [modalType]);
};
